import { Heading } from '@efdigital/ll-addon-ui';
import { PAGE_WRAPPER_CHROME } from '@efdigital/ll-xceed-v2/utils/layout';
import { LinkTo } from '@ember/routing';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

interface SettingsSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

export default class SettingsTemplate extends Component<SettingsSignature> {
  @service declare router: RouterService;

  ariaCurrent = (routeName: string): 'page' | undefined =>
    this.router.currentRouteName === routeName ? 'page' : undefined;

  <template>
    {{pageTitle "Settings"}}
    <div class={{PAGE_WRAPPER_CHROME}}>
      <Heading
        @size="lg"
        @text="Settings"
        @secondary="Manage your coach profile, notification preferences, and account settings."
        @class="mb-4"
      />

      <nav class="mb-4" aria-label="Settings sections">
        <ul
          class="nav nav-pills nav-fill coaching-dashboard-coach-tabs ll-bg-raised rounded-4 rounded-md-pill p-1 shadow-sm w-100 flex-nowrap flex-column flex-md-row"
        >
          <li class="nav-item">
            <LinkTo
              @route="coaching.coach.settings.index"
              class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center w-100"
              aria-current={{this.ariaCurrent "coaching.coach.settings.index"}}
            >
              Profile
            </LinkTo>
          </li>
          <li class="nav-item">
            <LinkTo
              @route="coaching.coach.settings.availability"
              class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center w-100"
              aria-current={{this.ariaCurrent
                "coaching.coach.settings.availability"
              }}
            >
              Calendar Sync &amp; Working Hours
            </LinkTo>
          </li>
          <li class="nav-item">
            <LinkTo
              @route="coaching.coach.settings.availability-preview"
              class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center w-100"
              aria-current={{this.ariaCurrent
                "coaching.coach.settings.availability-preview"
              }}
            >
              Availability Preview
            </LinkTo>
          </li>
        </ul>
      </nav>
    </div>
    {{outlet}}
  </template>
}
